import { asTruthSink, type TruthSink } from '../shared/truth-sink';
import { ws } from './state';
import { MemoryTruthSink } from './memory-truth-sink';
import { compileLocalTruthBase, heldDefinitionInputs } from './base-patch';
import type { BaseEnvelope } from '../janus-engine/compile/base-patch';

let installedSink: TruthSink | null = null;

export function ftCurrentTruthSink(): TruthSink | null {
    return asTruthSink(installedSink);
}

/** Install before starting gameplay. Clearing it restores the ordinary transport. */
export function ftInstallTruthSink(sink: TruthSink | null): void {
    installedSink = sink;
    if (ftCurrentTruthSink() && ws && ws.readyState < 2) ws.close(1000, 'local truth sink');
}

export function createMemoryTruthSink(envelope: BaseEnvelope, project?: (computed: Record<string, unknown>, base: Record<string, unknown>) => void): MemoryTruthSink {
    // A status a commit adds borrows its definition from where the page already holds it (tgstale28c); the page's exact-id reader
    // (an allowed catalog read) serves one it does not.
    return new MemoryTruthSink(envelope, compileLocalTruthBase, project, { held: id => heldDefinitionInputs(id, envelope.engine),
        fetch: ids => (window as unknown as { ftFetchObjectsBatch?: (ids: readonly string[]) => Promise<void> }).ftFetchObjectsBatch?.(ids) ?? Promise.resolve() });
}

Object.assign(window, { ftInstallTruthSink, ftCurrentTruthSink, ftCreateMemoryTruthSink: createMemoryTruthSink });
export type { TruthSink };
